import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useMenuItems } from '@admin/preferences/MainPreferences/data/MenuItems'

export const Route = createFileRoute('/_auth/preferences/')({
  component: RouteComponent,
})

function RouteComponent() {
  const menuItems = useMenuItems()

  // Find the first available menu item to redirect to
  const firstItem = menuItems[0]?.items[0]

  if (!firstItem) {
    return <div>No preferences available</div>
  }

  // Check if it's an expandable menu item or a simple menu item
  const redirectPath =
    'items' in firstItem
      ? (firstItem.items[0]?.link.to ?? '/preferences/users')
      : (firstItem.link.to ?? '/preferences/users')

  return <Navigate to={redirectPath} replace />
}
